import type { ComponentPropsWithoutRef } from 'react'

const ModalFooter = ({ className = '', ...props }: ComponentPropsWithoutRef<'footer'>) => (
  <footer className={`absolute inset-x-0 bottom-0 h-21 border-t border-gray-500 p-5 ${className}`} {...props} />
)

export default ModalFooter
